
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaLock, FaUser, FaKey, FaArrowLeft } from 'react-icons/fa';
import { BeatLoader } from 'react-spinners';
import axios from 'axios';
import '../styles/RecuperarContrasena.css';

const RecuperarContrasena = () => {
  const [step, setStep] = useState(1);
  const [legajo, setLegajo] = useState('');
  const [claveAnterior, setClaveAnterior] = useState('');
  const [nuevaClave, setNuevaClave] = useState('');
  const [confirmarClave, setConfirmarClave] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [intentosFallidos, setIntentosFallidos] = useState(0);
  const navigate = useNavigate();

  const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:4004').replace(/\/$/, '');

  const validarCredenciales = async () => {
    const response = await axios.post(`${API_URL}/api/auth/login`, {
      usuario: legajo,
      clave: claveAnterior
    });

    return response.data.token;
  };

  const cambiarClave = async () => {
    const response = await axios.post(`${API_URL}/api/auth/cambiar-password`, {
      usuario: legajo,
      clave: nuevaClave
    });

    return response.data.success;
  };

  const handleSubmitCredenciales = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!legajo || !claveAnterior) {
      setError('Complete todos los campos');
      return;
    }

    if (intentosFallidos >= 3) {
      setError('Se excedieron los intentos. Contacte a RRHH.');
      return;
    }

    setIsLoading(true);
    try {
      const token = await validarCredenciales();
      if (token) {
        setStep(2);
      } else {
        throw new Error('Credenciales inválidas');
      }
    } catch (err) {
      const nuevosIntentos = intentosFallidos + 1;
      setIntentosFallidos(nuevosIntentos);
      setError(
        nuevosIntentos >= 3
          ? 'Intentos excedidos. Contacte a RRHH.'
          : `Credenciales inválidas. Intentos restantes: ${3 - nuevosIntentos}`
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitNuevaClave = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (nuevaClave.length < 4) {
      setError('La nueva clave debe tener al menos 4 caracteres');
      return;
    }

    if (nuevaClave !== confirmarClave) {
      setError('Las claves no coinciden');
      return;
    }

    setIsLoading(true);
    try {
      const ok = await cambiarClave();
      if (!ok) throw new Error('No se pudo cambiar la contraseña');
      setSuccess('Contraseña cambiada exitosamente');
      setTimeout(() => navigate('/'), 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudo cambiar la contraseña');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="recover-container">
      <div className="recover-card">
        <button className="back-button" onClick={() => navigate(-1)}>
          <FaArrowLeft /> Volver
        </button>

        <div className="recover-header">
          <FaLock size={32} className="lock-icon" />
          <h2>{step === 1 ? 'Verificar Credenciales' : 'Nueva Contraseña'}</h2>
        </div>

        {step === 1 ? (
          <form onSubmit={handleSubmitCredenciales} className="recover-form">
            <div className="form-group">
              <label htmlFor="legajo"><FaUser className="input-icon" /> Legajo</label>
              <input
                id="legajo"
                type="text"
                value={legajo}
                onChange={(e) => setLegajo(e.target.value.replace(/\D/g, ''))}
                placeholder="Ingrese su legajo"
                required
                disabled={isLoading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="claveAnterior"><FaKey className="input-icon" /> Clave Actual</label>
              <input
                id="claveAnterior"
                type="password"
                value={claveAnterior}
                onChange={(e) => setClaveAnterior(e.target.value)}
                placeholder="Ingrese su clave actual"
                required
                disabled={isLoading}
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="submit-button" disabled={isLoading}>
              {isLoading ? <BeatLoader size={8} color="#fff" /> : 'Validar'}
            </button>
          </form>
        ) : (
          <form onSubmit={handleSubmitNuevaClave} className="recover-form">
            <div className="form-group">
              <label htmlFor="nuevaClave">Nueva Contraseña</label>
              <input
                id="nuevaClave"
                type="password"
                value={nuevaClave}
                onChange={(e) => setNuevaClave(e.target.value)}
                placeholder="Mínimo 4 caracteres"
                required
                disabled={isLoading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="confirmarClave">Confirmar Contraseña</label>
              <input
                id="confirmarClave"
                type="password"
                value={confirmarClave}
                onChange={(e) => setConfirmarClave(e.target.value)}
                placeholder="Repita su nueva contraseña"
                required
                disabled={isLoading}
              />
            </div>

            {error && <div className="error-message">{error}</div>}
            {success && <div className="success-message">{success}</div>}

            <button type="submit" className="submit-button" disabled={isLoading}>
              {isLoading ? <BeatLoader size={8} color="#fff" /> : 'Cambiar Contraseña'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default RecuperarContrasena;

